module.exports = __webpack_public_path__ + "assets/HKNova-Thin.ttf";


//////////////////
// WEBPACK FOOTER
// ./fonts/HKNova-Thin.ttf
// module id = 150
// module chunks = 0